import { createSlice } from "@reduxjs/toolkit"

const initialState = {
    showAlert: false,
    actionableAlert: false,
    isSuccess: true,
    message: '',
    actionFullfilled: false
}

const alertSlice = createSlice({
    name: 'alert',
    initialState,
    reducers: {
        setShowAlert:  (state, action) => {
            state.showAlert = action.payload
        },
        setActionableAlert: (state, action) => {
            state.actionableAlert = action.payload
        },
        setAlertMode: (state, action) => {
            state.isSuccess = action.payload
        },
        setMessage: (state, action) => {
            state.message = action.payload
        },
        setActionFullfilled: (state,action) => {
            state.actionFullfilled = action.payload
        }
    }
})

export const { setActionableAlert, setAlertMode, setMessage, setShowAlert, setActionFullfilled } = alertSlice.actions
export default alertSlice.reducer